import { render } from "./IconGroupOfCode.vue?vue&type=template&id=ac6f224e"
import script from "./IconGroupOfCode.vue?vue&type=script&lang=ts"
export * from "./IconGroupOfCode.vue?vue&type=script&lang=ts"
script.render = render

export default script